import styles from './states.module.css';

/** Every route-level screen must define a loading state (skill 17). */
export function LoadingState({ label }: { label: string }) {
  return (
    <div className={styles.state} role="status" aria-live="polite">
      {/* Decorative: the label is what a screen reader announces. */}
      <span className={styles.spinner} aria-hidden="true" />
      <p className={styles.message}>{label}</p>
    </div>
  );
}
